<div [formGroup]="form">
  <div class="input-panel">
    <div class="input-label">{{ 'settings.bankName' | translate }}</div>
    <div class="input-field">
      <mat-select class="form-control" formControlName="bankId" [placeholder]="'common.selectPlaceholder' | translate">
        <mat-option *ngFor="let bank of bankList" [value]="bank.id">
          {{ bank.name }}
        </mat-option>
      </mat-select>
    </div>
  </div>
  <div class="input-panel">
    <div class="input-label">{{ 'settings.accountNumber' | translate }}</div>
    <div class="input-field">
      <input
        class="form-control"
        formControlName="accountNumber"
        type="text"
        digitOnly
        maxlength="31"
      />
    </div>
    <div
      class="error"
      *ngIf="
        showFormError &&
        form.controls.accountNumber.errors &&
        form.controls.accountNumber.errors.pattern
      "
    >
      {{ 'settings.enterNumberOnly' | translate }}
    </div>
  </div>
  <div class="input-panel">
    <div class="input-label">{{ 'settings.accountHolder' | translate }}</div>
    <div class="input-field">
      <input class="form-control" formControlName="accountHolder" type="text" maxlength="255" />
    </div>
  </div>
</div>
